import { vuexTypes } from '../types'
import { notificationsService } from '@api/notifications.service'
import { isCryptoAsset, formatTokenDisplay } from '@utils/consts'

function roundCurrency2 (input) {
  let num = parseFloat(input)
  let formatted = num.toFixed(6)
  let trimmed = parseFloat(formatted).toString()
  if (!trimmed.includes('.')) {
    trimmed += '.00'
  } else {
    let parts = trimmed.split('.')
    if (parts[1].length < 2) {
      trimmed += '0'.repeat(2 - parts[1].length)
    }
  }
  return trimmed
}

function getInitialState () {
  return {
    messages: [],
    sseInitiated: false,
    eventSource: null
  }
}

const state = getInitialState()

const mutations = {
  SET_LOGGED_OUT_STATE (state) {
    if (state.eventSource) {
      state.eventSource.close()
    }
    Object.assign(state, getInitialState())
  },
  SET_NOTIFICATION_EVENT_SOURCE (state, eventSource) {
    state.eventSource = eventSource
    state.sseInitiated = true
  },
  UPDATE_MESSAGES (state, messages) {
    if (!Array.isArray(messages)) {
      state.messages = []
      return
    }

    state.messages = messages
      .map(el => {
        const params = (el && el.params) ? el.params : {}
        const asset = typeof params.asset === 'string' ? params.asset : ''
        const amount = params.amount

        // форматируем asset
        let formattedAsset = formatTokenDisplay(asset)

        // форматируем amount
        let formattedAmount = amount
        if (isCryptoAsset(asset)) {
          formattedAmount = roundCurrency2(Number(amount) || 0)
        }

        return {
          ...el,
          params: {
            ...params,
            asset: formattedAsset,
            amount: formattedAmount
          }
        }
      })
      .sort(function (a, b) {
        return new Date(b.updated_at) - new Date(a.updated_at)
      })
  },
  /**
   *
   * @param state
   * @param event MessageEvent
   * @constructor
   */
  SSE_NEW_MESSAGES (state, event) {
    if (event.data === 'null') {
      return
    }

    const array = JSON.parse(event.data)
    for (const message of array) {
      state.messages.push(message)
    }
    state.messages = state.messages.map(el => {
      return {
        ...el,
        params: {
          ...el.params,
          amount: isCryptoAsset(el.params.asset) ? roundCurrency2(Number(el.params.amount)) : el.params.amount,
          asset: formatTokenDisplay(el.params.asset)
        }
      }
    }).sort((a, b) => new Date(b.updated_at) - new Date(a.updated_at))
  }
}

const actions = {
  async GET_UNREAD_MESSAGES ({ state, commit }) {
    if (!state.sseInitiated) {
      const eventSource = notificationsService.sse((event) => commit(vuexTypes.SSE_NEW_MESSAGES, event))
      commit('SET_NOTIFICATION_EVENT_SOURCE', eventSource)
    }
    const resp = await notificationsService.loadUnreadNotifications()
    if (resp._parsedData.messages) {
      const uniqueArray = resp._parsedData.messages.filter((value, index, self) =>
        index === self.findIndex((t) => t.id === value.id)
      )
      commit(vuexTypes.UPDATE_MESSAGES, uniqueArray)
    } else {
      commit(vuexTypes.UPDATE_MESSAGES, [])
    }
  },
  async MARK_READ_MESSAGES ({ state, commit }, filter) {
    await notificationsService.readMessages(filter)
    let buf = []
    for (const message of state.messages) {
      if (filter.indexOf(message.id) === -1) {
        buf.push(message)
      }
      commit(vuexTypes.UPDATE_MESSAGES, buf)
    }
  }
}

const getters = {
  getUnreadMessages: state => state.messages
}

export default {
  actions,
  getters,
  mutations,
  state
}



// WEBPACK FOOTER //
// ./src/vuex/modules/notifications.module.js